import { useCallback } from 'react'
import { useQueryParams } from '@fs/zion-router'
import {
  useSharedBrowserDispatchContext,
  useSharedBrowserStateContext,
} from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'
import { useR2StateContext } from '../../../providers/r2Provider/R2Context'
import { getImagesFromApidList } from '../../../../shared/utils/getImagesFromApidList'

export default function useSetApidSubgroup() {
  const sharedBrowserState = useSharedBrowserStateContext()
  const sharedBrowserDispatch = useSharedBrowserDispatchContext()
  const { setQuery } = useQueryParams({ replaceState: true })

  const r2State = useR2StateContext()

  const { viewMode, unifiedApidList } = sharedBrowserState
  const { childGroups } = r2State

  const setItem = useCallback(
    (childGroupId) => {
      setQuery({ groupId: childGroupId })
      if (viewMode === 'group') {
        // Get the index of the first item in the selected group and just set the focusedIndex
        // This acts as a way to scroll rather than changing the thumbnails to a subset of images
        // If we decide we want to change to a subset of images, we can do that here
        const firstChild = childGroups.find((childObject) => childObject.parentId === childGroupId).childIds[0]
        const selectedApidIndex = unifiedApidList.findIndex((apid) => apid === firstChild)
        sharedBrowserDispatch({
          type: 'SET_FOCUSED_INDEX',
          value: selectedApidIndex,
        })
      } else if (viewMode === 'single') {
        // Get the new set of thumbnails with the childGroupId
        const selectedGroupIds = childGroups.find((group) => group.parentId === childGroupId).childIds
        const newThumbnails = getImagesFromApidList(selectedGroupIds)
        sharedBrowserDispatch({
          type: 'BATCH',
          value: [
            { type: 'SET_FOCUSED_INDEX', value: 0 },
            { type: 'SET_THUMBNAILS', value: newThumbnails },
          ],
        })
      }
    },
    [childGroups, sharedBrowserDispatch, unifiedApidList, viewMode, setQuery]
  )

  return setItem
}
